import { render, staticRenderFns } from "./InformacoesMonitoramento.vue?vue&type=template&id=01797a29&scoped=true&lang=pug"
import script from "./InformacoesMonitoramento.vue?vue&type=script&lang=js"
export * from "./InformacoesMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./InformacoesMonitoramento.vue?vue&type=style&index=0&id=01797a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01797a29",
  null
  
)

export default component.exports